import PageView from "@/views/Page.vue";
export const noticeRouter = {
  path: "/notice",
  redirect: {
    name: "noticeIndex"
  },
  component: PageView,
  children: [
    {
      path: "list",
      name: "noticeList",
      component: () => import("@/views/notice/list.vue"),
      meta: {
        title: "公告"
      }
    },
    {
      path: "detail",
      name: "noticeDetail",
      component: () => import("@/views/notice/detail.vue"),
      meta: {
        title: "公告详情"
      }
    }
  ]
};
